import { render } from "./YourDetailsHVN copy.vue?vue&type=template&id=5908c996&scoped=true"
import script from "./YourDetailsHVN copy.vue?vue&type=script&lang=js"
export * from "./YourDetailsHVN copy.vue?vue&type=script&lang=js"

import "./YourDetailsHVN copy.vue?vue&type=style&index=0&id=5908c996&lang=scss"
import "./YourDetailsHVN copy.vue?vue&type=style&index=1&id=5908c996&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5908c996"]])

export default __exports__